module.exports = __webpack_public_path__ + "img/26.30e8c48a.png";